<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('leave.title1') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.report') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('leave.title1') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
							  <el-input v-model="keywords" 
							      :placeholder="$t('offer.payment.search')"
							      style="width:100%"
							    ></el-input>
							</div>
							<h5 class="mb-0">
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel"></el-button>
								</el-tooltip>
								<el-tooltip :content="$t('dashboard.refresh')" placement="top">
									<el-button type="text" class="el-icon-refresh" @click="refreshData"></el-button>
								</el-tooltip>
							</h5>
						</div>
						<div class="card-body">
							<el-table
						    :data="filteredData"
						    style="width: 100%"
						    max-height="520"
						    :cell-class-name="tableCellClassName"
						    @cell-click="handleCellEvent"
						    :row-class-name="tableRowClassName">
						    <el-table-column
						      prop="name"
						      :label="$t('leave.name')"
						      width="150"
						      fixed
						      sortable>
						    </el-table-column>
						    <el-table-column
						      prop="team"
						      :label="$t('leave.team1')"
						      width="150"
						      sortable
						      :filters="teamFilter"
			                  :filter-method="filterHandler">
						      <template slot-scope="scope">
						        {{ getTeam(scope.row.team) }}
						      </template>
						    </el-table-column>
						    <el-table-column
						      prop="practiceId"
						      :label="$t('leave.practice')"
						      width="150"
						      sortable
						      :filters="practiceFilter"
			                  :filter-method="filterHandler">
						      <template slot-scope="scope">
						        {{ getPractice(scope.row.practiceId) }}
						      </template>
						    </el-table-column>
						    <el-table-column :label="m" v-for="(m, i) in months">
						      <el-table-column
						        prop="leave[i].annualLeave"
						        :label="$t('leave.annual-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[i].annualLeave }}
						        </template>
						      </el-table-column>
						      <el-table-column
						        prop="leave[i].sickLeave"
						        :label="$t('leave.sick-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[i].sickLeave }}
						        </template>
						      </el-table-column>
						      <el-table-column
						        prop="leave[i].specialLeave"
						        :label="$t('leave.special-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[i].specialLeave }}
						        </template>
						      </el-table-column>
						    </el-table-column>
						    <!--<el-table-column :label="leave.sum">
						      <el-table-column
						        prop="leave[13].annualLeave"
						        :label="$t('leave.annual-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[13].annualLeave }}
						        </template>
						      </el-table-column>
						      <el-table-column
						        prop="leave[13].sickLeave"
						        :label="$t('leave.sick-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[13].sickLeave }}
						        </template>
						      </el-table-column>
						      <el-table-column
						        prop="leave[13].specialLeave"
						        :label="$t('leave.special-leave')"
						        width="120">
						        <template slot-scope="scope">
						          {{ scope.row.leave[13].specialLeave }}
						        </template>
						      </el-table-column>
						    </el-table-column>-->
						    <el-table-column
						      prop="left"
						      :label="$t('leave.remain-days-ty')"
						      width="180"
						      sortable>
						    </el-table-column>
						  </el-table>
						</div>
					</div>	
				</div>
			</div>
		</div>
    	<!-- Modal -->
	    <el-dialog :title="$t('leave.title3')" 
	      :visible.sync="showModal"
	      width="80%"
	      top="30px"
	      :append-to-body="true">
	      <el-timeline>
		    <el-timeline-item
		      v-for="d in detail"
		      :color="leaveType(d.leaveType)"
		      :timestamp="d.startDate">
		      {{d.reason}}
		    </el-timeline-item>
		  </el-timeline>
	      <div slot="footer" class="dialog-footer">
	        <el-button @click="showModal = false">{{ $t('leave.close') }}</el-button>
	      </div>
	    </el-dialog>
	</div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'LeaveReport',
  data: function() {
	return {
	  data: null,
	  showModal: false,
	  detail: null,
	  keywords: null
	}
  },
  computed: {
    filteredData: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.data) return []
      return this.data.filter(item => {
		if (item.name.toLowerCase().includes(k)) {
		  return item
		}
	  })
    },
    years: function() {
      let thisYear = moment().year(),
          years = []
      for (let i = 2018; i <= thisYear; i ++)
        years.push(i)

      return years
    },
    months: function() {
      let months = [],
          lang = this.$i18n.locale
      if (lang === 'zh')
  	    moment.locale('zh-cn')
      else
  	    moment.locale(lang)

      for (let i = 1; i <= 12; i ++)
        months.push(moment('2019-' + ((i < 10) ? '0' + i : i) + '-01').format('MMM'))

      months.push(this.$t('leave.sum'))
      return months
    },
    teamFilter: function() {
      let f = []
      for (let i = 0; i < this.team.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.team[i]['c_name'] : this.team[i]['e_name'],
        	value = this.team[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    practiceFilter: function() {
      let f = []
      for (let i = 0; i < this.practice.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.practice[i]['c_name'] : this.practice[i]['e_name'],
        	value = this.practice[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    }
  },
  watch: {
  },
  methods: {
    leaveType: function(v) {
      if (v == 0) return '#1C9F0F'
      else if (v == 1) return '#160F9F'
      else if (v == 2) return '#9F0F44'
      else return '#dddddd'
    },
    tableCellClassName: function({row, column, rowIndex, columnIndex}) {
      row.index = rowIndex
      column.index = columnIndex
    },
    handleCellEvent: function(row, column, cell, event) {
      console.log(column.index)
      let that = this,
          query = '?userId=' + row.userId
	  this.$http.get(this.API3_PREFIX + 'leave_report_detail' + query).then(function (response) {
		that.detail = response.data
      }).catch(function (error) {
		console.log(error)
      })
      this.showModal = true
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    refreshData: function() {
      this.loadData()
    },
    exportExcel () {
	  let wb = XLSX.utils.table_to_book(document.querySelector('#leave-report'))
	  /* get binary string as output */
	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
	  try {
	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-LeaveReport.xlsx')
	  } catch (e) {
	    if (typeof console !== 'undefined')
	      console.log(e, wbout)
	  }
	  return wbout
    },
    tableRowClassName({row, rowIndex}) {
      if (row.active == 0) {
        return 'success-row';
      }
      return '';
    },
    loadData: function() {
      let that = this,
          query = '?userId=' + localStorage.getItem('token')
	  this.$http.get(this.API3_PREFIX + 'leave_report' + query).then(function (response) {
		that.data = response.data
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>